import { WorkOrderItemType } from "features/WorkOrders/constants/work-order-item.constants";
import type { PettyWorkItem } from "features/PettyWorks/types/petty-work.types";
import { pettyWorkLineQuantity } from "features/PettyWorks/utils/petty-work.utils";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

function pettyLineTypeToQuotationType(
  raw: PettyWorkItem["type"],
): QuotationItemType {
  if (
    raw === WorkOrderItemType.MATERIAL ||
    raw === WorkOrderItemType.LABOR ||
    raw === WorkOrderItemType.SERVICE
  ) {
    return raw as QuotationItemType;
  }
  return QuotationItemType.MATERIAL;
}

/** Map petty work BOQ lines into rows for {@link BoqItemsFieldArray} / quotation BOQ shape. */
export function pettyWorkItemsToMrBoqRows(
  items: PettyWorkItem[] | null | undefined,
): QuotationItemFormRow[] {
  const rows = items ?? [];
  if (rows.length === 0) return [];
  return rows.map((item) => {
    const type = pettyLineTypeToQuotationType(item.type);
    const qty = pettyWorkLineQuantity(item);
    const rate = Number.isFinite(Number(item.rate)) ? Number(item.rate) : 0;
    const description = String(item.description ?? "").trim();
    const unit = String(item.unit ?? "").trim();
    const id =
      item.id != null && Number.isFinite(Number(item.id)) && Number(item.id) > 0
        ? Number(item.id)
        : undefined;
    return {
      ...(id != null ? { id } : {}),
      type,
      description,
      quantity: qty > 0 ? qty : 1,
      unit,
      rate,
    };
  });
}
